import { PaginationModel } from 'model/Pagination.dto';
import { ProjectModel } from 'api/dto/Project.dto';
import { ProjectSettingsModel } from 'api/dto/ProjectSettings.dto';
import { PulseTemplateModel } from 'api/dto/PulseTemplate.dto';
import { Resource } from 'model/Resource';
import { ProjectLayoutState } from 'reduxStore/project/projectLayout/initialState';

export const STORE_NAME = 'project';

export namespace ProjectState {
  export type ProjectList = ProjectModel[];
  export type ProjectListResource = Resource<ProjectList>;
  /**
   * This could be normal project (e.g.: Engagement or CAS)
   * or PulseTemplate with additional information about pulses, ODP, and lifecycles
   */
  export type CurrentProject = ProjectModel | PulseTemplateModel;
  export type ProjectCurrentResource = Resource<CurrentProject>;
  export type ProjectSettingsResource = Resource<ProjectSettingsModel>;
  export type WebLinkResource = string;
  export type ProjectListPagination = PaginationModel | null;
  export type SubProjects = {
    current: Resource<ProjectModel>;
    list: Resource<ProjectModel[]>;
    liveAndScheduled: Resource<ProjectModel[]>;
    pagination: PaginationModel | null;
  };

  // TODO refactor, split this to states depending on what type of project is selected Normal / Pulse / ODP etc.
  export type Domain = {
    listResource: ProjectListResource;
    currentResource: ProjectCurrentResource;
    layoutResource: ProjectLayoutState.Domain;
    settingsResource: ProjectSettingsResource;
    webLinkResource: WebLinkResource;
    listPagination: ProjectListPagination;
    subProjects: SubProjects;
    isPulseTemplateFullyLoaded: boolean;
    pulseTemplateRequestId: string;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource<ProjectList>(),
    currentResource: Resource.createPendingResource<CurrentProject>(),
    layoutResource: ProjectLayoutState.INITIAL_DOMAIN,
    settingsResource: Resource.createPendingResource<ProjectSettingsModel>(),
    webLinkResource: '',
    listPagination: null,
    subProjects: {
      list: Resource.createPendingResource<ProjectModel[]>(),
      liveAndScheduled: Resource.createPendingResource<ProjectModel[]>(),
      current: Resource.createPendingResource<ProjectModel>(),
      pagination: null,
    },
    isPulseTemplateFullyLoaded: false,
    pulseTemplateRequestId: '',
  };
}
